<template>
  <div>
    <el-button type="primary" @click="visible = true">{{ btnText }}</el-button>

    <div>
      <el-tag
        v-for="(item, index) in employeeList"
        :key="item.employeeId"
        class="m-t-15 m-r-10"
        closable
        @close="deleteApprover(index)"
      >
        {{ item.name }}
      </el-tag>
    </div>

    <select-employee-dialog
      :show-dialog.sync="visible"
      :title="btnText"
      :echo-list="employeeList"
      multiple
      @confirm="confirm"
    />
  </div>
</template>

<script>
import SelectEmployeeDialog from '@/components/common/SelectEmployeeDialog'

export default {
  name: 'SelectApproverDialog',

  components: {
    SelectEmployeeDialog
  },

  model: {
    prop: 'list',
    event: 'change'
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },

    btnText: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false
    }
  },

  computed: {
    employeeList: {
      get() {
        return this.list.map(value => {
          return {
            employeeId: value.id,
            name: value.name
          }
        })
      },
      set(val) {
        this.$emit(
          'change',
          val.map(value => {
            return {
              id: value.employeeId,
              name: value.name
            }
          })
        )
      }
    }
  },

  methods: {
    confirm(employeeInfo) {
      if (Array.isArray(employeeInfo)) {
        this.employeeList = employeeInfo
      } else {
        this.employeeList.push(employeeInfo)
      }
    },

    deleteApprover(index) {
      this.employeeList = this.employeeList
        .map((value, valueIndex) => {
          if (index === valueIndex) return undefined
          return value
        })
        .filter(value => value)
    }
  }
}
</script>
